module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/banner-195a88de305498cc22f5c25383b75282.svg";